/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".location-check[_ngcontent-%COMP%]{font-size:14pt;color:#495057}.ips-checked-card[_ngcontent-%COMP%]{background-color:#dff0d8;border-color:#228b22}.ips-checked-card[_ngcontent-%COMP%]   .location-check[_ngcontent-%COMP%]{color:#228b22}div.modal-scrollable.list-search-infinite-container[_ngcontent-%COMP%]{min-height:0}"];
export { styles as styles };
